import { useWatch } from 'react-hook-form';

import { Fields } from '../constants';
import type { SecretFormValues } from '../schemas';

export const useSecretFormHasPasskey = () => {
    const passkey = useWatch<SecretFormValues, Fields.PASSKEY>({ name: Fields.PASSKEY });

    return !!passkey?.credentialId;
};
